var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Retriever } from "../../../../common";
export class MarketGroupsRetriever extends Retriever {
    constructor(marketGroupsGateway, dictionary) {
        super();
        this.marketGroupsGateway = marketGroupsGateway;
        this.isActive = false;
        this.dictionary = dictionary;
    }
    activate(state) {
        return __awaiter(this, void 0, void 0, function* () {
            this.isActive = true;
            this.state = state;
            yield this.refreshData();
        });
    }
    deactivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isActive = false;
        });
    }
    setParams(leagueId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.leagueId = leagueId;
            yield this.refreshData();
            if (this.state && this.state.Items.length) {
                this.state.selectItem(this.state.Items[0]);
            }
        });
    }
    onPanelEnter() { }
    onPanelLeave() { }
    refreshData() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isActive && this.leagueId && (yield this.pullItems(this.leagueId));
        });
    }
    pullItems(leagueId) {
        return __awaiter(this, void 0, void 0, function* () {
            const marketGroups = yield this.marketGroupsGateway.GetMarketGroups(leagueId, this.dictionary.AllOutrights);
            this.isActive && this.state.replaceItems(marketGroups, true);
        });
    }
}
//# sourceMappingURL=MarketGroupsRetriever.js.map